import { useCallback, useEffect, useState } from 'react';

import { IoArrowBack } from 'react-icons/io5';
import { useHistory, useParams } from 'react-router-dom';

import FormIndicationView from '@components/forms/FormIndicationView';
import {
  ButtonDefault,
  HeaderNavigationPrivate,
  LoadingForm,
  MenuSideBarPrivate,
  SubtitleSecondary,
} from '@components/index';
import Indication from '@models/Indication';
import { apiRebox } from '@services/index';
import { generateDate } from '@utils/generators';

import { IUrlParams } from './typing';

import {
  Container,
  ContainerGroup,
  Content,
  Options,
  OptionsGroup,
} from './styles';

const IndicationShow: React.FC = () => {
  const { goBack } = useHistory();

  const { id: indicationId } = useParams<IUrlParams>();

  const [loading, setLoading] = useState<boolean>(false);
  const [indication, setIndication] = useState<Indication>({} as Indication);

  const getIndication = useCallback(async () => {
    try {
      setLoading(true);
      const {
        data: { data: indicationData },
      } = await apiRebox.get(`/indications/${indicationId}`);
      setIndication(indicationData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleGoBack = () => {
    goBack();
  };

  useEffect(() => {
    getIndication();
  }, []);

  return (
    <Container>
      <HeaderNavigationPrivate />
      <ContainerGroup>
        <MenuSideBarPrivate />
        <Content>
          <SubtitleSecondary textAlign="start">Indicação</SubtitleSecondary>
          <Options>
            <OptionsGroup>
              <ButtonDefault iconLeft={IoArrowBack} onClick={handleGoBack} />
            </OptionsGroup>
          </Options>
          {loading ? (
            <LoadingForm />
          ) : (
            <FormIndicationView indication={indication} />
          )}
        </Content>
      </ContainerGroup>
    </Container>
  );
};

export default IndicationShow;
